module.exports = __webpack_public_path__ + "img/unicorn-display.20a62772.jpeg";